export default {
  resetSelection(context) {
    const tempSelection = {
      index:              [0],
      selectionCreatedBy: 'none',
    };
    context.commit('updateSelection', tempSelection);
  },
};
